<template>
  <modal
    :ok-disabled="loading"
    :ok-title="!edit ? 'Pridať' : 'Upraviť'"
    :title="!edit ? 'Pridať časy' : 'Upraviť časy'"
    cancel-title="Zrušiť"
    full-height
    name="add-time"
    scrollable
    size="md"
    type="from-right"
    @hidden="Object.assign($data, $options.data())"
    @ok="save"
    @show="fetchData"
  >
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeShort">
        <div v-if="!loading" ref="scroll" v-bar>
          <div>
            <div v-for="(time, i) in form.time" :key="i" class="row">
              <div class="col-6">
                <b-form-group
                  label-cols-sm="2"
                  label="Od"
                  :label-for="`timefrom${i}`"
                >
                  <b-form-input
                    v-model="time.from"
                    v-validate="{
                      regex: '^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$',
                    }"
                    data-vv-as="Od"
                    :class="{ 'is-invalid': errors.has(`timefrom${i}`) }"
                    :name="`timefrom${i}`"
                  />
                  <b-form-invalid-feedback>
                    {{ errors.first(`timefrom${i}`) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
              <div class="col-6">
                <b-form-group
                  label-cols-sm="2"
                  label="Do"
                  :label-for="`timeto${i}`"
                >
                  <b-form-input
                    v-model="time.to"
                    v-validate="{
                      regex: '^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$',
                    }"
                    data-vv-as="Do"
                    :class="{ 'is-invalid': errors.has(`timeto${i}`) }"
                    :name="`timeto${i}`"
                  />
                  <b-form-invalid-feedback>
                    {{ errors.first(`timeto${i}`) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>
            <b-btn
              class="mb-3"
              size="sm"
              variant="outline-primary"
              @click.prevent="addRow"
            >
              <icon class="icon-fw" name="plus" />
            </b-btn>
            <b-form-group label-cols-sm="5" label="Platné od" label-for="from">
              <single-date
                v-model="form.from"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('from') }"
                class="form-control"
                data-vv-as="Platné od"
                name="from"
              />
              <b-form-invalid-feedback>
                {{ errors.first('from') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-cols-sm="5" label="Platné do" label-for="to">
              <single-date
                v-model="form.to"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('to') }"
                class="form-control"
                data-vv-as="Platné do"
                name="to"
              />
              <b-form-invalid-feedback>
                {{ errors.first('to') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>
      </transition>
    </b-overlay>
  </modal>
</template>
<script>
import Modal from '@/components/Modal'
import SingleDate from '@/components/inputs/SingleDate'

export default {
  components: {
    Modal,
    SingleDate,
  },
  data() {
    return {
      loading: false,
      edit: false,
      id: null,
      form: {
        time: [{ from: null, to: null }],
      },
    }
  },
  methods: {
    addRow() {
      this.form.time.push({ from: null, to: null })
    },
    save(e) {
      e.preventDefault()
      this.$validator.validateAll().then(() => {
        if (!this.errors.any() && !this.loading) {
          if (this.edit) {
            this.$api
              .post('energetics/edit_time', this.form)
              .then((res) => {
                this.$swal({
                  type: 'success',
                  position: 'top',
                  showCloseButton: true,
                  text: res.data.message,
                  timer: 5000,
                })
                this.$root.$emit('modal-hide', 'add-time')
                this.$root.$emit('reloadEnergeticTimeData')
              })
              .catch(() => {
                this.$swal({
                  type: 'error',
                  position: 'top',
                  showCloseButton: true,
                  text: 'Vyskytla sa chyba pri aktualizovaní hodnôt',
                  timer: 5000,
                })
              })
          } else {
            this.$api
              .post('energetics/add_time', this.form)
              .then((res) => {
                this.$swal({
                  type: 'success',
                  position: 'top',
                  showCloseButton: true,
                  text: res.data.message,
                  timer: 5000,
                })
                this.$root.$emit('reloadEnergeticTimeData')
                this.$root.$emit('modal-hide', 'add-time')
              })
              .catch(() => {
                this.$swal({
                  type: 'error',
                  position: 'top',
                  showCloseButton: true,
                  text: 'Vyskytla sa chyba pri pridávaní hodnôt',
                  timer: 5000,
                })
              })
          }
        } else {
          this.$swal({
            type: 'warning',
            position: 'top',
            showCloseButton: true,
            text: 'Formulár nieje správne vyplnený',
            timer: 5000,
          })
        }
      })
    },
    fetchData() {
      this.form.energetics_id = parseInt(this.$route.params.energetics_id)

      if (this.edit) {
        this.loading = true
        this.$api.get(`energetics/${this.id}/time/get_form`).then((res) => {
          this.form = res.data.data
          this.loading = false
        })
      }
    },
  },
}
</script>
